import { memo, FunctionComponent, useMemo, useCallback } from 'react';
import { Item as ItemType, Odd as OddType } from '~types';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import Currency from '~components/Currency';
import { Price } from '~ui/index';
import { GetName, SteamItemImage } from '~components/item';
import { useConfig, useGetGaTestId } from '~components/hooks';
import { useMount } from 'react-use';
import { useYaMetrica } from '~frontend/provider/yametrica';
import './itemStyles.scss';

import playAudio from '~frontend/utils/playAudio';

interface ItemProps {
  getItem: ItemType;
  getOdd: OddType;
}

const Item: FunctionComponent<ItemProps> = ({ getItem, getOdd }) => {
  const getChance =
    getOdd?.itemsPercents[_.replace(getItem.name, /.*(StatTrak™)./gm, '')];
  const getConfig = useConfig();

  let [ga_ab] = useGetGaTestId();
  if (getConfig.isEU) ga_ab = 1;
  const yametrica = useYaMetrica();

  // useMount(() => {
  //   yametrica.sendApi(1, 'event', 'experiment_impression', {
  //     experiment_id: 'show_drop_chance',
  //     variant_id: `show_drop_chance.${ga_ab}`,
  //     send_to: 'G-C5XHV4XCZ9',
  //   });
  // });

  const rars = useMemo(
    () =>
      _.map(
        _.orderBy(
          _.filter(getOdd?.itemsOdds, ['name', getItem.name]),
          ['price'],
          ['desc'],
        ),
        (item, index) => (
          <div className="case_contains_hover_row" key={item.id}>
            <div
              className={`case_contains_hover_cell case_contains_hover_cell_highlight`}
            >
              {item.quality}
            </div>
            <div className="styles.case_contains_hover_cell">
              {getConfig.isEU ? (
                <>
                  <Currency />
                  <Price sum={item.price} />
                </>
              ) : (
                <>
                  <Price sum={item.price} />
                  <Currency />
                </>
              )}
            </div>
            <div
              className={`case_contains_hover_cell ${
                (index + 1) % 2 !== 0
                  ? 'case_contains_hover_cell_highlight'
                  : ''
              }`}
            >
              {item.chance.toFixed(3)}
            </div>
          </div>
        ),
      ),
    [getItem.name, getOdd?.itemsOdds],
  );

  // Объект с сопоставлением цветов и названий классов
  const rarityColors = {
    b0c3d9: 'case_contains_item_consumer',
    '4b69ff': 'case_contains_item_military',
    '5e98d9': 'case_contains_item_industrial',
    '8847ff': 'case_contains_item_restricted',
    d32ce6: 'case_contains_item_classified',
    eb4b4b: 'case_contains_item_covert',
    ffc600: 'case_contains_item_legendary',
    ffd700: 'case_contains_item_legendary',
    ffc700: 'case_contains_item_legendary',
    e4ae39: 'case_contains_item_legendary',
  };

  // Функция для получения названия класса по цвету
  const getRarityClassName = useCallback((color) => {
    return rarityColors[color] || '';
  }, []);

  const [itemName, itemSkin] = getItem.getName.split('|');

  return (
    <div className={`case_contains_item ${getRarityClassName(getItem.color)}`}>
      <div className="case_contains_hover">
        <div className="case_contains_hover_table">
          <div className="case_contains_hover_row">
            <div className="case_contains_hover_cell">Q</div>
            <div className="styles.case_contains_hover_cell">
              Price <Currency />
            </div>
            <div className="case_contains_hover_cell">Odds %</div>
          </div>
          {rars}
          {/* <div className="case_contains_hover_row">
            <div
              className={`case_contains_hover_cell case_contains_hover_cell_highlight`}
            >
              {getItem.quality}
            </div>
            <div className={styles.case_contains_hover_cell}>1136592</div>
            <div
              className={`${styles.case_contains_hover_cell} ${styles.case_contains_hover_cell_highlight}`}
            >
              {item.chance}
            </div>
          </div>
          <div className={styles.case_contains_hover_row}>
            <div className={styles.case_contains_hover_cell}>WW</div>
            <div className={styles.case_contains_hover_cell}>35.15</div>
            <div className={styles.case_contains_hover_cell}>0.012</div>
          </div>
          <div className={styles.case_contains_hover_row}>
            <div
              className={`${styles.case_contains_hover_cell} ${styles.case_contains_hover_cell_highlight}`}
            >
              MW
            </div>
            <div className={styles.case_contains_hover_cell}>41.5</div>
            <div
              className={`${styles.case_contains_hover_cell} ${styles.case_contains_hover_cell_highlight}`}
            >
              0.019
            </div>
          </div>
          <div className={styles.case_contains_hover_row}>
            <div className={styles.case_contains_hover_cell}>ST</div>
            <div className={styles.case_contains_hover_cell}>72.26</div>
            <div className={styles.case_contains_hover_cell}>0.013</div>
          </div> */}
        </div>
      </div>
      <div className="item_chance">{getChance}%</div>
      <div className="item_image_container1">
        <SteamItemImage
          src={`${getItem.getImage}/180x120`}
          alt={getItem.getName}
          width={180}
          height={120}
          className="item_image"
        />
      </div>
      <div className="item_info">
        <div className="item_name">{itemName}</div>
        <div className="item_skin1">{itemSkin}</div>
      </div>
    </div>
    // <div
    //   className="in-case-item status-1"
    //   data-rar={getItem.color}
    //   onMouseEnter={playAudio}
    //   data-audio="5.wav"
    //   data-volume="0.4"
    // >
    //   {ga_ab === 1 && (
    //     <div className="in-case-item-stats">
    //       {getChance && <div className="drop-chance">{getChance}%</div>}
    //     </div>
    //   )}
    //   <div className="in-case-item-wrap">
    //     <div className="in-case-item-rar-table-wrap">
    //       <div className="in-case-item-rar-table">
    //         <div className="in-case-item-rar-table-head">
    //           <span>Quality</span>
    //           <span>Price</span>
    //           {ga_ab === 1 && <span>Odds</span>}
    //         </div>
    //         {rars}
    //       </div>
    //     </div>
    //     <div className="img">
    //       <div className="in-case-item-bg" />
    //       <div className="other-labels-item">
    //         {getItem.isStatTrak && (
    //           <div className="stattrack">
    //             <span className="fas fa-star" /> StatTrak™
    //           </div>
    //         )}
    //       </div>

    //       <SteamItemImage
    //         src={`${getItem.getImage}/350x262`}
    //         alt={getItem.getName}
    //       />
    //       <div className="honey"></div>
    //     </div>
    //     <div className="in-case-info">
    //       <div className="in-case-item-name">
    //         <GetName getItem={getItem} type={0} />
    //       </div>
    //       <div className="in-case-item-desc">
    //         <GetName getItem={getItem} type={1} />
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default memo(Item);
